import { Link, useLink, usePageContent } from "@appiodev/xcore-client/xcore-ui";
import { Box, Stack, Typography } from "@xcorejs/ui";
import LeftMenu from "design-system/robe/LeftMenuContainer/LeftMenu";
import FormControl from "design-system/xcore/Form/FormControl";
import Select from "design-system/xcore/Select";
import { FC, useMemo } from "react";
import { useLayout } from "xcore";
import { Office } from "xcore/types";

const ContactMenu: FC = () => {
  const [{ id }, { stringify }] = usePageContent<Office>();
  const { header } = useLayout();
  const { push } = useLink();

  const options = useMemo(() => header.nav.offices.values.officeList?.filter(c => c.offices).map(c => ({
    label: stringify(c.header) ?? "",
    options: c.offices!.map(o => ({ label: stringify(o.values.title) ?? "", value: o }))
  })), [header.nav.offices.values.officeList, stringify]);

  const onChange = selectedOption => {
    push(selectedOption.value);
  };

  return (
    <Box width="100%">
      <FormControl display={{ _: "flex", md: "none" }}>
        <Select
          placeholder={stringify(header.nav.offices.values.mobileDropdownPlaceholder)}
          options={options}
          onChange={onChange}
        />
      </FormControl>

      <Stack gap="3rem" direction="column" display={{ _: "none", md: "flex" }}>
        {header.nav.offices.values.officeList?.map((c, i) =>
          c.offices && (
            <Box width="100%" key={i}>
              <Typography variant="h3" as="h2" mb={{ _: "1.5rem" }} textAlign={{ _: "center", md: "left" }}>
                {stringify(c.header)}
              </Typography>
              <LeftMenu>
                <Stack
                  gap="1.5rem"
                  direction={{ _: "row", md: "column" }}
                  wrap="wrap"
                  justify={{ _: "center", md: "flex-start" }}
                >
                  {c.offices.map(o => (
                    <Link key={o.id} content={o} className={o.id === id ? "active" : ""}>
                      <span>{stringify(o.values.title)}</span>
                    </Link>
                  ))}
                </Stack>
              </LeftMenu>
            </Box>
          ))}
      </Stack>
    </Box>
  );
};

export default ContactMenu;
